var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlaceholderBusiness = function SvgPlaceholderBusiness(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M70.15625,46.40625 L81.09375,46.40625 L81.09375,75.3125 L38.90625,75.3125 L38.90625,46.40625 L49.84375,46.40625 L49.84375,41.328125 C49.84375,40.3678337 50.1896124,39.5418329 50.8813477,38.8500977 C51.5730829,38.1583624 52.3990837,37.8125 53.359375,37.8125 L66.640625,37.8125 C67.6009163,37.8125 68.4269171,38.1583624 69.1186523,38.8500977 C69.8103876,39.5418329 70.15625,40.3678337 70.15625,41.328125 L70.15625,46.40625 Z M77.1875,71.40625 L77.1875,50.3125 L56.875,50.3125 L56.875,46.40625 L66.25,46.40625 L66.25,41.71875 L53.75,41.71875 L53.75,50.3125 L42.8125,50.3125 L42.8125,71.40625 L77.1875,71.40625 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder-business.a5b3792b65cea42f342d14610cfe3ed7.svg";